import { Product } from '../product.model';

/** Active for storefront: status done/active (or legacy 1). */
export function isStorefrontActiveProduct(product: Product): boolean {
  const status = product.products_status as string | number | undefined;
  return status === 'done' || status === 'active' || status === 1 || status === '1';
}

/** Active and in stock — Shop nav link + storefrontHasProductsGuard. */
export function isStorefrontSellableProduct(product: Product): boolean {
  return isStorefrontActiveProduct(product) && (product.products_quantity ?? 0) > 0;
}
